import { render } from "./vc-pinboard-item.html?vue&type=template&id=e78977a0"
import script from "./VcPinboardItem.vue?vue&type=script&lang=ts"
export * from "./VcPinboardItem.vue?vue&type=script&lang=ts"

import "./vc-pinboard-item.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script